import PropTypes from 'prop-types';
import ListFilter from 'Shared/components/list-filter';
import addDays from 'date-fns/addDays';
import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import parseISO from 'date-fns/parseISO';
import { removeTimeFromDate } from 'Shared/util/formatters';


export const ALL = 'ALL';
export const UNPAYED = 'UNPAYED';
export const PAYED = 'PAYED';
export const OVERDUE = 'OVERDUE';
export const SOLD = 'SOLD';
export const MONITORED = 'MONITORED';
export const CREDIT = 'CREDIT';
export const SOLD_WITHOUT_CREDIT = 'SOLD_WITHOUT_CREDIT';
export const MONITORED_WITHOUT_CREDIT = 'MONITORED_WITHOUT_CREDIT';

const stateFilter = (invoice, { state }) => {
  switch (state) {
    case UNPAYED:
      return !invoice.payed;
    case PAYED:
      return invoice.payed;
    case OVERDUE: { // 'now' is greater than due date + 1 day?
      const now = parseISO(invoice.referenceDate);
      const due = parseISO(invoice.dueDate);
      return !invoice.payed
        && isAfter(now, addDays(due, 1));
    }
    case SOLD:
      return invoice.serviceId !== 2;
    case MONITORED:
      return invoice.serviceId === 2;
    case CREDIT:
      return invoice.hasCreditTransaction;
    case SOLD_WITHOUT_CREDIT:
      return (invoice.serviceId !== 2 && !invoice.hasCreditTransaction);
    case MONITORED_WITHOUT_CREDIT:
      return (invoice.serviceId === 2 && !invoice.hasCreditTransaction);
    case ALL:
    default:
      return true;
  }
};

const minDate = new Date(1, 0, 1);
const maxDate = new Date(9999, 0, 1);

const invoiceDateFilter = (invoice, { filterDateBy = 'invoiceDate', fromDate, toDate }) => {
  if (isAfter((fromDate || minDate), (toDate || maxDate))) return false;

  const dateWithoutTime = removeTimeFromDate(parseISO(invoice[filterDateBy]));

  return isWithinInterval(dateWithoutTime, {
    start: fromDate || minDate,
    end: toDate || maxDate,
  });
};

const debtorFilter = (invoice, { debtor }) => {
  if (!debtor || debtor.trim().length === 0) return true;
  return invoice.debtor.toLowerCase().includes(debtor.toLowerCase());
};


const InvoiceFilter = ({
  items,
  render,
  default: defaultFilter,
  dismissExportAlert,
}) => (
  <ListFilter
    filterActions={[
      stateFilter,
      invoiceDateFilter,
      debtorFilter,
    ]}
    items={items}
    render={render}
    default={defaultFilter}
    dismissExportAlert={dismissExportAlert}
  />
);

InvoiceFilter.propTypes = {
  items: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
  default: PropTypes.object,
  dismissExportAlert: PropTypes.func,
};

export default InvoiceFilter;
